<template>
  <div class="tool-content-sections">
    <section
      v-for="(block, index) in sections"
      :key="index"
      class="tool-section"
    >
      <h2>{{ block.h2 }}</h2>
      <p v-for="(paragraph, pIndex) in block.paragraphs" :key="'p-' + pIndex" v-html="paragraph" />
      <ul v-if="block.list && block.list.length">
        <li v-for="(item, lIndex) in block.list" :key="'l-' + lIndex" v-html="item" />
      </ul>
      <ol v-if="block.steps && block.steps.length">
        <li v-for="(step, sIndex) in block.steps" :key="'s-' + sIndex" v-html="step" />
      </ol>
      <div v-if="block.cards && block.cards.length" class="tool-cards">
        <div v-for="(card, cIndex) in block.cards" :key="'c-' + cIndex" class="tool-card">
          <strong>{{ card.title }}</strong>
          {{ card.text }}
        </div>
      </div>
      <table v-if="block.table" class="tool-compare-table">
        <thead>
          <tr>
            <th v-for="(head, hIndex) in block.table.headers" :key="'h-' + hIndex">{{ head }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rIndex) in block.table.rows" :key="'r-' + rIndex">
            <td v-for="(cell, cellIndex) in row" :key="'cell-' + rIndex + '-' + cellIndex" v-html="cell" />
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ToolContentSections',
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
};
</script>
